import storeInit from "storeInit";

export default function getWorkshop(){
  return storeInit.getState().workshop;
}
